function crc16(str: string): string {
  let crc = 0xffff;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
    }
  }
  return ((crc & 0xffff).toString(16).toUpperCase().padStart(4, "0"));
}

function tlv(id: string, value: string): string {
  return id + value.length.toString().padStart(2, "0") + value;
}

export function generatePixPayload(pixKey: string, amount: number, merchantName: string, city: string): string {
  const name = merchantName.slice(0, 25).normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-zA-Z0-9 ]/g, "");
  const cityNorm = city.slice(0, 15).normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-zA-Z0-9 ]/g, "");
  const amountStr = amount.toFixed(2);
  const gui = "BR.GOV.BCB.PIX";
  const mai = tlv("00", gui) + tlv("01", pixKey);
  const payload =
    tlv("00", "01") +
    tlv("26", mai) +
    tlv("52", "0000") +
    tlv("53", "986") +
    tlv("54", amountStr) +
    tlv("58", "BR") +
    tlv("59", name) +
    tlv("60", cityNorm) +
    tlv("62", tlv("05", "***")) +
    "6304";
  return payload + crc16(payload);
}
